import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

// SweetAlert 공통 스타일 설정
const baseConfig = {
  position: "bottom-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  background: "#1a1a1a",
  color: "#ffffff",
  toast: true,
  customClass: {
    popup: "custom-swal-popup",
    title: "custom-swal-title",
    content: "custom-swal-content",
  },
};

// SweetAlert2 전역 설정 초기화 함수
export const initSweetAlert = (app) => {
  app.use(VueSweetalert2, baseConfig);

  // 전역 swal 유틸리티 등록
  app.config.globalProperties.$swal = createSwalUtil(app);
};

// SweetAlert 유틸리티 생성 함수
const createSwalUtil = (app) => {
  const swal = app.config.globalProperties.$swal;

  const processOptions = (options) => {
    return typeof options === 'string' ? { title: options } : options;
  };

  return {
    // 기본 alert
    alert: (options) => swal({ 
      ...baseConfig, 
      ...processOptions(options) 
    }),
    
    // 성공 메시지
    success: (options) => swal({
      ...baseConfig,
      icon: "success",
      iconColor: "#4CAF50",
      ...processOptions(options)
    }),

    // 에러 메시지
    error: (options) => swal({
      ...baseConfig,
      icon: "error", 
      iconColor: "#ff3e3e",
      ...processOptions(options)
    }),

    // 경고 메시지
    warning: (options) => swal({
      ...baseConfig,
      icon: "warning",
      iconColor: "#ff9800",
      ...processOptions(options)
    }),

    // 정보 메시지
    info: (options) => swal({
      ...baseConfig,
      icon: "info",
      iconColor: "#2196F3",
      ...processOptions(options)
    }),

    // 확인 다이얼로그
    confirm: (options) => swal({
      ...baseConfig,
      position: "center",
      icon: "question",
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: "OK",
      cancelButtonText: "Cancel",
      toast: false,
      ...processOptions(options),
    })
  };
};
